import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import dayjs from 'dayjs';
import {
  CTA,
  CustomDatePicker,
  CustomInput,
  CustomSelect,
  Modal,
  Text,
} from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import SortBy from '../../SortBy';
import { FiltersWrapper } from './style';
import { getFilterLabel, getFilterOptions } from '../../../../utils/labels';
import { LOGS_LIST_GET } from '../../../../app/redux/actions/supervisorStats';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

export const ModalFiltersLogsId = 'ModalFiltersLogs';

//? mostly a copy of ModalFilters
const ModalFiltersLogs = ({
  mediaIsPhone,
  children,
  modalClose,
  onClick,
  filters = {},
  activeFilters = {},
  getLogsList,
}) => {
  const scrollableAreaRef = useRef(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isSearchAvailable, setIsSearchAvailable] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [advancedSearch, setAdvancedSearch] = useState(false);

  useEffect(() => {
    return () => {
      modalClose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedFilters({ ...activeFilters });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(activeFilters).length]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value || value?.id;
    setSelectedFilters(newFilters);
  };

  const formatOptions = (options = []) => {
    const opts = (options || []).map((o) => {
      if (o?.key && o?.value) {
        return {
          label: o?.value,
          value: o?.key,
        };
      }
      return o;
    });
    return opts;
  };

  const getSelectedFilter = (key) => {
    if (!selectedFilters[key]) return null;
    return formatOptions(filters[key]).find(
      (o) => (o?.value || o?.id) === selectedFilters[key]
    );
  };

  useEffect(() => {
    const { start_date, end_date, table, roles, name, lastname, email, ffoo } =
      selectedFilters;
    let valid = Boolean(start_date && end_date && table && roles);

    if (advancedSearch) {
      valid = valid && Boolean(name || lastname || email || ffoo);
    }
    setIsSearchAvailable(valid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleGetLogsList = () => {
    const body = { ...selectedFilters };
    if (!advancedSearch) {
      delete body.name;
      delete body.lastname;
      delete body.email;
      delete body.ffoo;
    }
    if (isSearchAvailable) getLogsList(body);
  };

  const toggleAdvancedSearch = () => {
    const newFilters = { ...selectedFilters };
    if (!advancedSearch) newFilters.search_text = '';

    setSelectedFilters(newFilters);
    setAdvancedSearch(!advancedSearch);
  };

  return (
    <Modal
      title="Filtri"
      modalId={ModalFiltersLogsId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea ref={scrollableAreaRef}>
        {Object.keys(filters)?.length > 0 && (
          <>
            <Text type="b3" mb={8}>
              Seleziona i filtri da applicare:
            </Text>
            <FiltersWrapper>
              {Object.keys(filters).map((key, i) => {
                if (filters[key]?.length <= 0) return null;
                if (key === 'ffoo') return null;
                return (
                  <CustomSelect
                    key={`filter-${i}`}
                    placeholder={getFilterLabel(key)}
                    options={formatOptions(filters[key])}
                    onChange={(value) => handleOnChange({ key, value })}
                    isClearable
                    selected={getSelectedFilter(key)}
                  />
                );
              })}
              <CustomDatePicker
                id="start-log-modal-dp"
                placeholder="Data di inizio"
                onChange={(date) => {
                  setSelectedFilters({
                    ...selectedFilters,
                    start_date: date && dayjs(date).format('DD-MM-YYYY'),
                  });
                  setSelectedStartDate(date);
                }}
                value={selectedStartDate}
              />
              <CustomDatePicker
                id="end-log-modal-dp"
                placeholder="Data di fine"
                onChange={(date) => {
                  setSelectedFilters({
                    ...selectedFilters,
                    end_date: date && dayjs(date).format('DD-MM-YYYY'),
                  });
                  setSelectedEndDate(date);
                }}
                value={selectedEndDate}
              />
              <CTA
                type="tertiary"
                btnText="Ricerca avanzata"
                icon={advancedSearch ? 'chevron-up' : 'chevron-down'}
                onClick={toggleAdvancedSearch}
              />
              {advancedSearch && (
                <>
                  <CustomInput
                    size="full"
                    placeholder="Nome"
                    value={selectedFilters.name || ''}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({ ...selectedFilters, name: v })
                    }
                  />
                  <CustomInput
                    size="full"
                    placeholder="Cognome"
                    value={selectedFilters.lastname || ''}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({ ...selectedFilters, lastname: v })
                    }
                  />
                  <CustomInput
                    size="full"
                    placeholder="Email"
                    value={selectedFilters.email || ''}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({ ...selectedFilters, email: v })
                    }
                  />
                  <CustomSelect
                    size="full"
                    placeholder="Forza dell'ordine"
                    options={getFilterOptions(filters, 'ffoo')}
                    onChange={(value) => handleOnChange({ key: 'ffoo', value })}
                    isClearable
                    selected={getSelectedFilter('ffoo')}
                  />
                </>
              )}
              {children}
            </FiltersWrapper>
          </>
        )}
        <SortBy
          options={[
            { label: 'Dal più recente', value: 'created_desc' },
            { label: 'Dal meno recente', value: 'created_asc' },
          ]}
          onChange={(v) => {
            setSelectedFilters({
              ...selectedFilters,
              sort_by: v?.value,
            });
          }}
        />
      </ScrollableArea>
      <Footer>
        <CTA
          type="primary"
          btnText="Applica"
          fullsize={mediaIsPhone}
          onClick={() => {
            onClick(selectedFilters);
            handleGetLogsList();
            modalClose();
          }}
          disabled={!isSearchAvailable}
        />
      </Footer>
    </Modal>
  );
};

ModalFiltersLogs.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  filters: PropTypes.object,
  activeFilters: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getLogsList: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { filters, activeFilters, sorting } = state.app.modal.payload;
      return { filters, activeFilters, sorting };
    },
    (dispatch) => ({
      getLogsList: (filters) =>
        dispatch({ type: LOGS_LIST_GET._REQUEST, filters }),
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalFiltersLogs);
